
const errorDefaultState = {
    errors: []
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = errorDefaultState, action) => {
    switch (action.type) {
        case 'ADD_ERROR':
            const newState = {...state};
            newState.errors.push(action.error);
            
            return newState;
        default:
            return state;
    }
};